import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { inject, InjectionToken, PLATFORM_ID } from '@angular/core';

export const PLATFORM_TYPE = new InjectionToken('PLATFORM_TYPE', {
  providedIn: 'platform',
  factory: () => {
    const id = inject(PLATFORM_ID);

    if (isPlatformServer(id))
      return 'server';

    if (isPlatformBrowser(id)) {
      return 'browser';
    }

    throw new Error('could not identify platform type');
  }
});

export const IS_SERVER = new InjectionToken('IS_SERVER', {
  providedIn: 'platform',
  factory: () => inject(PLATFORM_TYPE) === 'server'
});

export const IS_BROWSER = new InjectionToken('IS_BROWSER', {
  providedIn: 'platform',
  factory: () => inject(PLATFORM_TYPE) === 'browser'
});

export const isServer = () => inject(IS_SERVER);
export const isBrowser = () => inject(IS_BROWSER);